<template lang="pug">
  .component-backoffice-coupon-list.row.column
    //pre {{data}}
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'PendingRecordsList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/WalletUninvoiced.vue'),
        data:[]
      }
    },
    created() {

    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        return KeplerBackofficeSdk.walletRecords.list(page, resultsPerPage).uninvoiced((data) => {
          callback(data)
          console.log(data)
          this.data = data
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// PendingRecordsList.vue?159e56a9